import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import ODLeavePieChart from "./ODLeaveChart";
import { getFinancialYearList } from "../../../core/common/financialYear";

const SelfOutDutyDashboard = () => {

    const formatFinancialYear = (year: number) => {
        const nextYearShort = (year + 1).toString().slice(-2);
        return `${year}-${nextYearShort}`;
    };

    const getFinancialYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        return formatFinancialYear(year);
    };

    const [finance_year, setFinance_year] = useState(getFinancialYear());


    const {
        data: leave_Balance_data,
        loading: leave_balance_loading,
        error: leave_balance_error,
    } = useApi("/api/view-leave-balance-dashboard", {
        method: "POST",
        payload: {
            financial_year: finance_year,
        },
        autoCall: true,
        dependencies: [finance_year],
    });


    useEffect(() => {
        console.log(finance_year, "finance_year");
        console.log(leave_Balance_data?.data, "leave_Balance_data");
    }, [])

    return (
        <>
            {/* <Loader loading={}/> */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-2">
                        <div className="my-auto mb-2">
                            <h2 className="mb-2">Out Duty Dashboard</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.employeeDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Work & Operations</li>
                                    <li className="breadcrumb-item">Out Duty</li>
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.seflGrid}>Self Out Duty</Link>
                                    </li>

                                    <li className="breadcrumb-item active" aria-current="page">
                                        Out Duty Dashboard
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                            <div className="me-2 mb-2"></div>
                            <div className="input-icon w-120 position-relative mb-2">
                                <span className="input-icon-addon">
                                    <i className="ti ti-calendar text-gray-9" />
                                </span>
                                <select
                                    value={finance_year}
                                    onChange={(e) => setFinance_year(e.target.value)}
                                    className="form-select"
                                >
                                    {getFinancialYearList().map((fy) => (
                                          <option key={fy} value={fy}>
                      {fy.split("-")[0]}
                    </option>
                                    ))}
                                </select>
                            </div>
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>



                    <div className="row">
                        <div className="col-12 mt-2">
                            <ODLeavePieChart financial_year={finance_year}/>
                        </div>

                    </div>

                </div>
                <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
                    <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
                </div>
            </div>


        </>
    );
};

export default SelfOutDutyDashboard;
